import { useState } from 'react';
import { Box } from '@mui/material';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import VisibilityOffOutlinedIcon from '@mui/icons-material/VisibilityOffOutlined';

const PasswordBox = ({ label, ...rest }) => {
    const [visible, setVisible] = useState(false);
    return (
        <Box position='relative'>
            {label && <label className='required' htmlFor="password">{label}</label>}
            <input type={visible ? 'text' : 'password'} className="form-control" id="password" {...rest} />
            <Box position='absolute' onClick={() => setVisible(!visible)} color='#BDBDCE' right='20px' bottom='15px' sx={{ cursor: 'pointer' }}>
                {
                    visible
                        ? <VisibilityOffOutlinedIcon  sx={{ fontSize: '24px' }} />
                        : <VisibilityOutlinedIcon sx={{ fontSize: '24px' }} />
                }
            </Box>
        </Box>
    )
}

export default PasswordBox;